"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DebounceManager_1 = __importDefault(require("../debounce/DebounceManager"));
var IframeUtility_1 = __importDefault(require("./IframeUtility"));
var IframeVisibleArea_1 = __importDefault(require("./IframeVisibleArea"));
/**
 * IframeVisibleAreaObserver.
 */
var IframeVisibleAreaObserver = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.callback
     * @param options.overflow
     * @param options.debounceTime
     */
    function IframeVisibleAreaObserver(options) {
        var _this = this;
        this.callback = null;
        this.debounce = new DebounceManager_1.default();
        this.debounceTime = null;
        this.overflow = false;
        this.isInsideIframe = IframeUtility_1.default.isInsideIframe();
        this.updateListener = function () {
            if (_this.debounceTime) {
                _this.debounce.set('update', _this.callback, _this.debounceTime);
            }
            else {
                _this.callback();
            }
        };
        this.debounceTime = options ? options.debounceTime : null;
        this.overflow = options ? options.overflow : false;
        this.callback = options
            ? function () { return options.callback(IframeVisibleArea_1.default.getArea(_this.overflow)); }
            : null;
    }
    /**
     * Start dispatching update events.
     */
    IframeVisibleAreaObserver.prototype.observe = function () {
        if (this.isInsideIframe) {
            window.parent.addEventListener('scroll', this.updateListener);
            window.parent.addEventListener('resize', this.updateListener);
            window.addEventListener('resize', this.updateListener);
        }
        else {
            throw 'IframeVisibleAreaObserver will only work from within an iframe. Use postions: sticky; instead';
        }
    };
    /**
     * Removes listeners.
     */
    IframeVisibleAreaObserver.prototype.disconnect = function () {
        if (this.isInsideIframe) {
            window.parent.removeEventListener('scroll', this.updateListener);
            window.parent.removeEventListener('resize', this.updateListener);
            window.removeEventListener('resize', this.updateListener);
            this.debounce.clearAll();
        }
    };
    /**
     * Returns bottom, top, left and right.
     *
     * @returns Position.
     */
    IframeVisibleAreaObserver.prototype.getArea = function () {
        return IframeVisibleArea_1.default.getArea(false);
    };
    return IframeVisibleAreaObserver;
}());
exports.default = IframeVisibleAreaObserver;
//# sourceMappingURL=IframeVisibleAreaObserver.js.map